import initHeaderLangSearch from "./initHeaderLangSearch";

export default function initHeader() {
  setHeaderHeight();

  scrollHeaderFixed();

  // 採用関連ページ: ヘッダー背景の透過切り替え
  initTransparentHeader();

  // メガメニュー
  initMegaMenu();

  // 言語切替・サイト内検索
  initHeaderLangSearch();
}

/**
 * ヘッダーの高さをCSS変数に設定する関数
 * 要素のリサイズを検知して再取得します。
 */
function setHeaderHeight(cssVariableName = "--header-height-gutter") {
  const header = document.querySelector(".js-header-fixed");
  if (!header) return;

  let headerH = header.clientHeight;
  document.documentElement.style.setProperty(cssVariableName, headerH + "px");

  // 要素のリサイズを監視して再取得
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      // ヘッダーの高さを再設定
      headerH = entry.target.clientHeight;
      document.documentElement.style.setProperty(
        cssVariableName,
        headerH + "px",
      );
    }
  });
  resizeObserver.observe(header);
}

/**
 * scrollでheader固定
 */
function scrollHeaderFixed() {
  const fixedHeader = document.querySelector(".js-header-fixed");

  if (!fixedHeader) return;

  function scrollHandler() {
    // 一定量スクロールしたら表示
    fixedHeader.classList.toggle("is-header-fixed", window.scrollY > 100);
  }

  window.addEventListener("scroll", scrollHandler);
  scrollHandler();
}

/**
 * 採用関連ページ: ヘッダー背景の透過切り替え
 *
 * - page-recruit: rc-mvセクションを超えたら白背景、戻ったら透過
 * - その他の採用関連ページ: 少しスクロールで白背景、戻ったら透過
 */
function initTransparentHeader() {
  const header = document.querySelector(".l-header--transparent");
  if (!header) return;

  const mvSection = document.querySelector(".rc-mv");

  // rc-mvがある場合（recruitページ）: mvの下端を超えたら白背景
  if (mvSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // rc-mvが画面外に出た = スクロールで超えた → 白背景ON
          // rc-mvが画面内に見えている = 戻ってきた → 白背景OFF
          header.classList.toggle("is-header-filled", !entry.isIntersecting);
        });
      },
      {
        // ヘッダー高さ分だけ上にオフセットして、mvがヘッダーの下に隠れたタイミングで発火
        rootMargin: "0px 0px 0px 0px",
        threshold: 0,
      },
    );
    observer.observe(mvSection);
  } else {
    // その他の採用関連ページ: 少しスクロール（50px）で白背景
    function scrollHandler() {
      header.classList.toggle("is-header-filled", window.scrollY > 50);
    }

    window.addEventListener("scroll", scrollHandler, { passive: true });
    scrollHandler();
  }
}

/**
 * メガメニュー制御
 * - #js-mega-trigger（li）にホバーで .l-header に .is-mega-open を付与
 * - .l-header-mega-menu は position:absolute で l-header 基準、z-index:0 でヘッダー要素より背面
 * - l-header-main は z-index:1 でメガメニュー白背景より前面に表示される
 */
function initMegaMenu() {
  const header = document.querySelector(".l-header");
  const trigger = document.getElementById("js-mega-trigger");
  const megaMenu = document.getElementById("js-mega-menu");
  const triggerLink = trigger?.querySelector(".l-header-nav__mega-trigger");
  const headerMain = document.querySelector(".l-header-main");
  const otherNavLinks = document.querySelectorAll(
    ".l-header-nav__item:not(#js-mega-trigger) a, .l-header-nav__cta a",
  );

  if (!header || !trigger || !megaMenu || !headerMain) return;

  let closeTimer = null;

  const open = () => {
    clearTimeout(closeTimer);
    header.classList.add("is-mega-open");
    triggerLink?.setAttribute("aria-expanded", "true");
    megaMenu.setAttribute("aria-hidden", "false");
  };

  const close = () => {
    header.classList.remove("is-mega-open");
    triggerLink?.setAttribute("aria-expanded", "false");
    megaMenu.setAttribute("aria-hidden", "true");
  };

  // わずかな遅延を挟んでホバーの途切れによる誤作動を防ぐ
  const closeWithDelay = () => {
    closeTimer = setTimeout(close, 100);
  };

  // トリガー li のホバー
  trigger.addEventListener("mouseenter", open);

  // l-header-main（ヘッダー全体）からマウスが外れたら閉じる（遅延あり）
  headerMain.addEventListener("mouseleave", closeWithDelay);
  // l-header-main 内にいる間は閉じるタイマーをキャンセル
  headerMain.addEventListener("mouseenter", () => clearTimeout(closeTimer));

  // メガメニューパネル内でのホバー維持
  megaMenu.addEventListener("mouseenter", () => clearTimeout(closeTimer));
  megaMenu.addEventListener("mouseleave", closeWithDelay);

  // 他のナビゲーションリンク、またはCTAボタンにホバーしたら即座に閉じる
  otherNavLinks.forEach((link) => {
    link.addEventListener("mouseenter", close);
  });

  // フォーカス制御（キーボードナビゲーション）
  trigger.addEventListener("focusin", open);
  trigger.addEventListener("focusout", (e) => {
    if (
      !trigger.contains(e.relatedTarget) &&
      !megaMenu.contains(e.relatedTarget)
    ) {
      close();
    }
  });
  megaMenu.addEventListener("focusout", (e) => {
    if (
      !trigger.contains(e.relatedTarget) &&
      !megaMenu.contains(e.relatedTarget)
    ) {
      close();
    }
  });

  // Escape キーで閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && header.classList.contains("is-mega-open")) {
      close();
      triggerLink?.focus();
    }
  });

  // メガメニュー内のリンクをクリックした時にメガメニューを閉じる
  const megaMenuLinks = megaMenu.querySelectorAll("a");
  megaMenuLinks.forEach((link) => {
    link.addEventListener("click", close);
  });
}
